import React from 'react';

const KubernetesPods = ({ pods, theme, borderColor, moduleCard }) => {
  if (!pods || pods.length === 0) return null;

  return (
    <div style={{ marginTop: 12, paddingTop: 12, borderTop: `1px dashed ${borderColor}` }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: theme.toolbar.text }}>
        Pods ({pods.length})
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {pods.map((pod) => (
          <div
            key={pod.id}
            style={{
              ...moduleCard,
              borderLeft: `3px solid ${
                pod.status === 'Running' ? '#4ade80' :
                pod.status === 'Pending' ? '#fbbf24' :
                '#ef4444'
              }`
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <div style={{ fontWeight: 600, color: theme.toolbar.text, fontSize: 13 }}>
                {pod.name}
              </div>
              <span style={{
                padding: '2px 6px',
                borderRadius: 3,
                fontSize: 10,
                fontWeight: 600,
                background: pod.status === 'Running'
                  ? (theme.name === 'dark' ? '#1e4d2b' : '#d1fae5')
                  : pod.status === 'Pending'
                    ? (theme.name === 'dark' ? '#4d3b1e' : '#fef3c7')
                    : (theme.name === 'dark' ? '#4a3b3b' : '#fee2e2'),
                color: pod.status === 'Running'
                  ? (theme.name === 'dark' ? '#4ade80' : '#065f46')
                  : pod.status === 'Pending'
                    ? (theme.name === 'dark' ? '#fbbf24' : '#92400e')
                    : (theme.name === 'dark' ? '#f87171' : '#991b1b')
              }}>
                {pod.phase}
              </span>
            </div>
            <div style={{ fontSize: 11, opacity: 0.7, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
              <div>Node: {pod.node_name}</div>
              <div>IP: {pod.ip}</div>
              <div>Restarts: {pod.restart_count}</div>
              <div>Containers: {pod.container_count}</div>
              {pod.namespace && <div>Namespace: {pod.namespace}</div>}
              {pod.owner_kind && <div>Owner: {pod.owner_kind}/{pod.owner_name}</div>}
            </div>
            {pod.cluster_id && (
              <div style={{ fontSize: 10, opacity: 0.6, marginTop: 4, fontFamily: 'monospace' }}>
                Cluster: {pod.cluster_id}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default KubernetesPods;
